import { createDirectus, readItems, rest } from "@directus/sdk";

export const clientRest = createDirectus("https://cms.sociometrik.com").with(
  rest()
);

export const getSeo = () => clientRest.request(readItems("seo"));
